import { Model } from '../parents/model';

export class OrderPaymentMethodModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_PRICE = 'price';

  static ATTR_TAXED_PRICE = 'taxed_price';

  static ATTR_PAYMENT_METHOD_ID = 'payment_method_id';

  static ATTR_ORDER_ID = 'order_id';

  static ATTR_CREATED_AT = 'created_at';

  static ATTR_UPDATED_AT = 'updated_at';

  static ATTR_NOTIFY_CHANGE = 'notify_change';

  static ATTR_NOTE = 'note';

  get name() {
    return this.attributes[OrderPaymentMethodModel.ATTR_NAME];
  }

  get price() {
    return this.attributes[OrderPaymentMethodModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[OrderPaymentMethodModel.ATTR_TAXED_PRICE];
  }

  get paymentMethodId() {
    return this.attributes[OrderPaymentMethodModel.ATTR_PAYMENT_METHOD_ID];
  }

  get orderId() {
    return this.attributes[OrderPaymentMethodModel.ATTR_ORDER_ID];
  }

  get createdAt() {
    return this.attributes[OrderPaymentMethodModel.ATTR_CREATED_AT];
  }

  get updatedAt() {
    return this.attributes[OrderPaymentMethodModel.ATTR_UPDATED_AT];
  }
}
